<template>
  <b-dropdown
    variant="link"
    menu-class="nav-item notification-box dropdown"
    class="no-after"
  >
    <template #button-content>
      <div class="nav-item notification-box dropdown">
        <div class="nav-link dropdown-toggle">
          <div class="notification-btn" :class="count && 'ring'" @click="fetchData">
            <i class="bx bx-bell"></i>
            <span v-if="count" class="badge badge-secondary">{{ count }}</span>
          </div>
        </div>
      </div>
    </template>
    <b-tabs justified >
      <b-tab >
        <template #title>
        <div class="titleTab titleRight">Thông báo</div>
      </template>
    <div
      class="notification-mark"
    >
    <span class="title d-inline-block">{{ count }} Thông báo mới</span>
    <span @click="readAll" class="buttonMark">Đánh dấu đã đọc</span>
  </div>
  <div class="dropdown-body py-0 height-fixed-245" style="min-width: 331px;">
    <!-- <div v-if="items.length === 0" class="text-center">
        <img src="@/assets/img/no-noti.png" width="185px">
        <p class="text-center d-block py-2 pb-3">
        <b-spinner
          v-if="loading"
          variant="primary"
          label="Spinning"
        ></b-spinner>
        <span class="cursor" @click="fetchData" v-else>Tải lại</span>
      </p>
      </div> -->
      <a
        href="javascript:;"
        @click="readOne(item)"
        class="dropdown-item d-flex align-items-center"
        :class="item.isRead ? 'read' : 'unread'"
        v-for="item in items"
        :key="item.id"
      >
        <div class="icon">
          <i class="bx bx-bell"></i>
        </div>
        <div class="content">
          <span class="d-block">{{ item.text }}</span>
          <p class="sub-text mb-0">{{ fromNow(item.createdTime) }}</p>
        </div>
      </a>
      <p v-if="items?.length > 0" class="text-center d-block py-2 pb-3">
        <b-spinner
          v-if="loading"
          variant="primary"
          label="Spinning"
        ></b-spinner>
        <span class="cursor" @click="fetchMore" v-else>Xem thêm</span>
      </p>
    </div>
  </b-tab>
  <b-tab>
    <template #title>
        <div class="titleTab titleLeft">Tin tức hệ thống</div>
      </template>
    <div class="dropdown-body py-0 height-fixed-245" style="min-width: 331px;">
    <div v-if="dataSystemNews?.length === 0" class="text-center">
        <img src="@/assets/img/no-noti.png" width="185px">
        <p class="text-center d-block py-2 pb-3">
        <b-spinner
          v-if="loading"
          variant="primary"
          label="Spinning"
        ></b-spinner>
        <span class="cursor" @click="fetchData" v-else>Tải lại</span>
      </p>
      </div>
      <a
        href="javascript:;"
        @click="readOne(item)"
        class="dropdown-item d-flex align-items-center read"
        v-for="item in dataSystemNews"
        :key="item.id"
      >
        <div class="icon">
          <i class="bx bx-bell"></i>
        </div>
        <div class="content">
          <span class="d-block">{{ item.content }}</span>
          <p class="sub-text mb-0">{{ fromNow(item.createdTime) }}</p>
        </div>
      </a>
      <p v-if="dataSystemNews?.length > 0" class="text-center d-block py-2 pb-3">
        <b-spinner
          v-if="loading"
          variant="primary"
          label="Spinning"
        ></b-spinner>
        <span class="cursor" @click="fetchMoreSystem" v-else>Xem thêm</span>
      </p>
    </div>
  </b-tab>
  </b-tabs>
    <!-- <div class="dropdown-footer">
      <a href="#" class="dropdown-item">Xem tất cả</a>
    </div> -->
  </b-dropdown>
</template>

<script>
import { CommonService } from '@/services/common.service'
import moment from 'moment'
import 'moment/locale/vi'
// import { messaging } from '@/config/firebaseConfig'
// import { showMess } from '@/config/utils'
// import { onMessage } from 'firebase/messaging';

moment.locale('vi')
export default {
  props: {},
  data () {
    return {
      items: [],
      limit: 10,
      count: 0,
      loading: false,
      limitSystem: 20,
      oldCount: 0,
      myInterval: {},
      dataSystemNews: {}
    }
  },
  async created () {
    this.fetchData()
    this.fetchDataSystemNews()
  },
  beforeDestroy () {
    clearInterval(this.myInterval)
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        const res = await CommonService.fetchNotification({
          page: 1,
          limit: this.limit,
          notificationOn: 'WEB'
        })
        this.items = res.data
        this.count = 0
        if (this.items?.length > 0) {
          this.items.forEach(val => {
            if (!val.isRead) {
              this.count++
            }
          })
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    async fetchDataSystemNews () {
      this.loading = true
      try {
        const res = await CommonService.fetchDataSystemNews({
          page: 1,
          limit: this.limitSystem,
        })
        this.dataSystemNews = res.data.list
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    fetchAgain () {
      if (this.oldCount < this.count) {
        this.limit = 20
        this.fetchData()
      }
    },
    fetchMore () {
      this.limit += 10
      this.fetchData()
    },
    fetchMoreSystem () {
      this.limitSystem += 10
      this.fetchDataSystemNews()
    },
    fromNow (createdTime) {
      return moment(createdTime).fromNow()
    },
    readOne (item) {
      if (item.isRead === false) {
        CommonService.readOneNotification(item.id)
        item.isRead = true
      }
      if (item.content.link) window.open(item.content.link, '_blank')
    },
    readAll () {
      CommonService.readAllNotification()
      this.items.forEach(s => (s.isRead = true))
      this.count = 0
    }
  },
  mounted() {
    // onMessage(messaging, (payload) => {
    //   const noti_title = payload.notification.title
    //   const noti_body = payload.notification.body
    //   showMess(this, noti_title, noti_body, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
    //   this.fetchData()
    // });
  }
}
</script>
<style scoped>
.titleTab{
  background-color: #0b62ab;
  color: #ffffff;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 9px;
  padding-bottom: 7px;
  text-align: center;
  font-weight: bold;
}
.titleRight {
  margin-right: -5px!important;
  border-top-left-radius: 5px;
}
.titleLeft {
  margin-left: -4px!important;
  border-top-right-radius: 5px;
}
.notification-mark{
  /* dropdown-header d-flex justify-content-between align-items-center  */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 8px 2px 8px;
  background-color: #c9c9c9;
  font-size: 14px;
  font-weight: bold;
}
.buttonMark{
  color: #2c8ad5;
  cursor: pointer;
}
</style>
